import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';

@Component({
  selector: 'app-patient-registration-date-wise',
  templateUrl: './patient-registration-date-wise.component.html',
  styleUrls: ['./patient-registration-date-wise.component.scss']
})
export class PatientRegistrationDateWiseComponent implements OnInit {
  public link: string = 'https://www.clickdimensions.com/links/TestPDFfile.pdf';
  fileName= 'ExcelSheet.xlsx';  
  showspinner = false;
  patientcount;
  dataSource = new MatTableDataSource<PatientDetailModel>();
  startdate;
  enddate;
  pname = "";
  pageHeading:any;
  isShowDivIf:boolean = false;
  
  constructor( 
    public opdvisitService: OpdVisitService,
    public datepipe: DatePipe,
    public dashboardService: DashboardService,private exportdata:ExportService) { 
     
    }

    displayedColumns: string[] = ['Patientid', 'Regdate', 'First_name', 'Last_name',
    'careofName','motherName','paddress','adharCardNo','oldMrno',
   'dob','phno','mobno'];

  ngOnInit(): void {
    // this.dataSource.data = this.opdvisitService.patients;
    // this.patientcount = this.opdvisitService.patients.length;
    this.pageHeading = 'Patient Registration Reports'
  }

    
toggleDisplayDivIf() {
  this.isShowDivIf = !this.isShowDivIf;
}
  
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
   
  }

  gettop_200byname(pname: string){
    if(pname){
      this.showspinner = true;
      this.dataSource.data = [];

      this.opdvisitService.get_top200_byname(pname).subscribe(
        data => this.successtop200(data), err => this.failedtop200(err)
      )
} 
else{
  this.dashboardService.openSnackBar("Please Enter Name First", "Ok");
}

  
  }
  successtop200(data){
    this.showspinner = false;
    this.opdvisitService.patients = [];
    this.opdvisitService.patients = data;
    this.dataSource.data = this.opdvisitService.patients;
   this.patientcount = this.opdvisitService.patients.length;
   // alert("api working");
  }

  failedtop200(err){
    // alert("api failed");
  }

  get_records_between_two_dates(){

   
    this.showspinner = true;
    this.dataSource.data = [];
   // this.dashboardService.selecteddate = this.datePipe.transform(selecteddate, "yyyy-MM-dd");
    let sdate = this.datepipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datepipe.transform(this.enddate, "yyyy-MM-dd");

   this.opdvisitService.get_pat_sdate_edate(sdate,edate).
   subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
 }

 success_pat_sdate_edate(data){
  
 this.showspinner = false;
 this.opdvisitService.patients = [];
 this.opdvisitService.patients = data;
 this.dataSource.data = this.opdvisitService.patients;
this.patientcount = this.opdvisitService.patients.length;
 }
failed_pat_sdate_edate(err){
this.showspinner = false;
}



selectpatient(selectedpatient: PatientDetailModel){

this.opdvisitService.getpatientdetails(selectedpatient.pkRegId);
//this.opdvisitService.patientdetails = selectedpatient;


}

exportexcel(): void 
    {
       let element = document.getElementById('content'); 
       this.exportdata.exportxcel(element);
     }

 
  public openPDF():void {
    let DATA = document.getElementById('content');
    this.exportdata.download(DATA);
        
  }
  
  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    this.exportdata.printData(printContents);
    
}

}
